import PropTypes from "prop-types";

//Formatea un RUT añadiendo puntos de miles y un guion antes del DV.
export const formatearRut = (rutInit) => {
  if (!rutInit) return "";
  let rut = rutInit.replace(/[^0-9kK]/g, "");

  const ultimoDigito = rut.substr(rut.length - 1, 1);
  const esK = ultimoDigito.toLowerCase() === "k";
  let dv = esK ? "K" : rut.substr(rut.length - 1, 1);

  rut = rut.substr(0, rut.length - 1);

  const rutFormateado = rut.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return `${rutFormateado}-${dv}`;
};

formatearRut.propTypes = {
  rutInit: PropTypes.string.isRequired,
};

export const formatearRsu = (num) => {
  return num.slice(0, 4) + "." + num.slice(4);
};

export const formatearFecha = (fecha) => {
  const date = new Date(fecha);
  const dia = date.getDate().toString().padStart(2, "0");
  const mes = (date.getMonth() + 1).toString().padStart(2, "0");
  const anio = date.getFullYear().toString();
  return `${dia}/${mes}/${anio}`;
};

//formatea el rut a medida se digita
export const formatRutToWrite = (value) => {
  const cleanValue = value.replace(/[.-]/g, "");

  const length = cleanValue.length;
  switch (length) {
    case 1:
      return cleanValue;
    case 2:
      return `${cleanValue[0]}.${cleanValue[1]}`;
    case 3:
      return `${cleanValue[0]}.${cleanValue.slice(1)}`;
    case 4:
      return `${cleanValue[0]}.${cleanValue.slice(1, 4)}`;
    case 5:
      return `${cleanValue[0]}.${cleanValue.slice(1, 4)}.${cleanValue[4]}`;
    case 6:
      return `${cleanValue[0]}.${cleanValue.slice(1, 4)}.${cleanValue.slice(
        4
      )}`;
    case 7:
      return `${cleanValue[0]}.${cleanValue.slice(1, 4)}.${cleanValue.slice(
        4,
        7
      )}`;
    case 8:
      return `${cleanValue[0]}.${cleanValue.slice(1, 4)}.${cleanValue.slice(
        4,
        7
      )}-${cleanValue.slice(7)}`;
    case 9:
      return `${cleanValue.slice(0, 2)}.${cleanValue.slice(
        2,
        5
      )}.${cleanValue.slice(5, 8)}-${cleanValue.slice(8)}`;
    default:
      return "";
  }
};

//formatear una cadena genérica para que números estén separados por "/" después de cada 4 dígitos
export const formatFolio = (value) => {
  const cleanValue = value.replace(/\D/g, "");

  let formattedValue = cleanValue.replace(/(.{4})/g, "$1/");

  if (formattedValue.length > 13 && formattedValue.endsWith("/")) {
    formattedValue = formattedValue.slice(0, -1);
  }

  return formattedValue;
};

//ajusta la primera parte para que tenga al menos 4 caracteres
export function formatearFolio(cadena) {
  const partes = cadena.split("/");
  const primeraParte = partes[0].padStart(4, "0");
  partes[0] = primeraParte;
  const cadenaFormateada = partes.join("/");
  return cadenaFormateada;
}

export const formatoMoneda = (valueIn = "") => {
  //formato esperado 100.100.100
  if (!valueIn) return;
  let value = valueIn;
  if (typeof valueIn !== "string") {
    value = valueIn.toString();
  }
  value.replaceAll("$", "").replaceAll(".", "");
  const numericValue = value.replace(/\D/g, "");
  const formatter = new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
  });
  let format = formatter.format(numericValue);
  return format.replaceAll("$", "");
};
